// src/types/product.types.ts
export interface ProductTag {
  id?: number;
  name: string;
  color?: string;
  description?: string;
}

export interface Product {
  id: number;
  code: string;
  name: string;
  type: string;
  categoryId?: number | null;
  status: 'ACTIVE' | 'INACTIVE';
  price: string;
  supplier: string;
  supplierId?: number | null;
  description?: string;
  weight?: number | string;
  length?: number | string;
  diameter?: string;
  material?: string;
  materialId?: number | null;
  color?: string;
  workshopCode?: string;
  tags?: ProductTag[];
  costPrice?: number | string;
  sellingPrice?: number | string;
  supplierCode?: string;
  // Additional fields that might be needed
  imagePath?: string;
  /** Matches products.has_thumbnail; list UI uses thumbnailUrl */
  hasThumbnail?: boolean;
  thumbnailUrl?: string | null;
  properties_description?: string;
  created_by?: string;
  /** ISO timestamps from API (catalog audit) */
  createdAt?: string;
  updatedAt?: string;
  /** Pieces at branch that are AVAILABLE or RESERVED */
  inStock?: number;
}

export interface ProductFilter {
  searchTerm: string;
  productType: string;
  productStatus: string;
  // Additional filter fields
  supplierId?: string;
  materialId?: string;
  tagId?: string;
  searchTag?: string;
  minWeight?: number;
  maxWeight?: number;
  diameterSize?: string;
  color?: string;
  workshopCode?: string;
}

export interface PaginationState {
  itemsPerPage: number;
  currentPage: number;
  totalItems: number;
}

/** Matches backend products list `sortBy` whitelist. */
export type ProductCatalogSortField =
  | 'updatedAt'
  | 'createdAt'
  | 'code'
  | 'name'
  | 'salePrice'
  | 'status'
  | 'weightGrams'
  | 'categoryName'
  | 'supplierName'
  | 'inStock';

export const DEFAULT_PRODUCT_CATALOG_SORT: {
  sortBy: ProductCatalogSortField;
  sortOrder: 'asc' | 'desc';
} = {
  sortBy: 'updatedAt',
  sortOrder: 'desc',
};

export interface ModalState {
  showModal: boolean;
  activeTab: 'basic' | 'category' | 'physical' | 'commercial' | 'supplier';
  modalPosition: {
    x: number;
    y: number;
  };
  isDragging: boolean;
  dragStart: {
    x: number;
    y: number;
  };
}

// API response types (to align with your API)
export interface ApiResponse<T> {
  data: T;
  meta?: {
    totalItems: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

// Map your API model to Product interface
export interface ApiProduct {
  id: number;
  code: string;
  name: string;
  description?: string;
  status: 'Activo' | 'Inactivo';
  cost_price?: number;
  selling_price: number;
  category?: { id: number; name: string };
  material?: { id: number; name: string };
  supplier?: { id: number; name: string };
  tags?: { id: number; name: string }[];
  // Add any additional API fields
}

// Product DTO interfaces for create/update operations
export interface CreateProductDto {
  code?: string;
  name: string;
  description?: string;
  status?: 'Activo' | 'Inactivo';
  cost_price?: number;
  selling_price: number;
  category_id?: number;
  material_id?: number;
  supplier_id?: number;
  color?: string;
  workshop_code?: string;
  tags?: string[];
  // Add other fields needed by your API
}

export interface UpdateProductDto {
  code?: string;
  name?: string;
  description?: string;
  status?: 'Activo' | 'Inactivo';
  cost_price?: number;
  selling_price?: number;
  category_id?: number;
  material_id?: number;
  supplier_id?: number;
  color?: string;
  workshop_code?: string;
  tags?: string[];
  // Add other fields needed by your API
}
